import script from "./TransferPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferPage.vue?vue&type=script&setup=true&lang=js"

import "./TransferPage.vue?vue&type=style&index=0&id=3d4223f6&scoped=true&lang=css"

import exportComponent from "/Users/muhammadaziziabdulaziz/Documents/VueProject/reeqzan/transfers/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4223f6"]])

export default __exports__